/* Cart drawer upsell (snippets/hc-cart-upsell.liquid). Appends "You might also like" under the cart lines every time
   hc-cart-drawer.js re-renders #cd-body. Rings come pre-ordered by review count; any ring already in the cart is skipped.
   Rings 2 and 3 are free through the admin discount (once per order), so the price reads FREE while the cart holds
   fewer rings than the offer size. */
(function(){
  var body=document.getElementById('cd-body'), el=document.getElementById('hc-upsell-data');
  if(!body||!el||window.hcUpsellOn) return; window.hcUpsellOn=true;
  var D={}; try{ D=JSON.parse(el.textContent); }catch(e){ return; }
  var RINGS=D.rings||[], MAX=D.max||3, OFFER=D.offer||3, MS=D.ms||'';
  function money(c){
    var n=Math.round(Number(c)||0), i=MS.indexOf('1'), j=MS.lastIndexOf('56'), m=(i>-1&&j>i)?MS.slice(i,j+2).match(/^1(\D?)234(\D?)56$/):null;
    if(!m) return '£'+(n/100).toFixed(2);
    return MS.slice(0,i)+String(Math.floor(n/100)).replace(/\B(?=(\d{3})+(?!\d))/g,m[1])+(m[2]||'.')+String(n%100).padStart(2,'0')+MS.slice(j+2);
  }
  function esc(t){ return String(t==null?'':t).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function clean(v){ return String(v).replace(/^No\s+/i,'').replace(/\s*\(adjustable\)$/i,'').trim(); }
  function isSize(name){ return /size/i.test(name); }
  function label(r,v){ return v.o.map(function(x,k){ var c=clean(x); return isSize(r.o[k]||'')&&/^\d/.test(c)?'Size '+c:c; }).join(', '); }   // "Size 7", "One size"
  // colour swatches + an optional size select; the chosen variant id lands on the row's data-id
  function swatchCtl(r,av,ci){
    var cols=[]; av.forEach(function(v){ if(cols.indexOf(v.o[ci])<0) cols.push(v.o[ci]); });
    var si=r.o.findIndex(isSize), sizes=[];
    if(si>-1) av.forEach(function(v){ if(sizes.indexOf(v.o[si])<0) sizes.push(v.o[si]); });
    var h='<span class="cu-sws" role="radiogroup" aria-label="Colour for '+esc(r.t)+'">'+cols.map(function(c){
      return '<button type="button" class="cu-sw sw-'+esc(String(c).toLowerCase().replace(/[^a-z0-9]+/g,'-'))+'" data-c="'+esc(c)+'" aria-label="'+esc(c)+'" title="'+esc(c)+'"><span></span></button>'; }).join('')+'</span>';
    if(sizes.length>1) h+='<select class="cu-sel cu-size" aria-label="Size for '+esc(r.t)+'"><option value="">Size</option>'+sizes.sort(function(a,b){ return (parseInt(a,10)||0)-(parseInt(b,10)||0); }).map(function(z){ return '<option value="'+esc(z)+'">'+esc(clean(z))+'</option>'; }).join('')+'</select>';
    return h;
  }
  function resolve(row){
    var r=RINGS.filter(function(x){ return x.h===row.getAttribute('data-h'); })[0]; if(!r) return '';
    var ci=r.o.findIndex(function(n){ return /colo/i.test(n); }), si=r.o.findIndex(isSize);
    var on=row.querySelector('.cu-sw.on'), sz=row.querySelector('.cu-size');
    var c=on?on.getAttribute('data-c'):null, z=sz?sz.value:null;
    var v=r.v.filter(function(x){ return x.a&&(ci<0||x.o[ci]===c)&&(si<0||!sz||x.o[si]===z); })[0];
    if(!c||(sz&&!z)||!v){ row.removeAttribute('data-id'); return ''; }
    row.setAttribute('data-id',v.id); return String(v.id);
  }
  function prompt(r){ var s=r.o.some(isSize), c=r.o.some(function(n){ return !isSize(n); }); return s&&c?'Colour and size':(s?'Choose size':'Choose colour'); }
  function inCart(){
    var vids={}, qty=0;
    body.querySelectorAll('.cd-item:not(.gift)').forEach(function(it){
      vids[it.getAttribute('data-vid')]=true;
      var q=it.querySelector('.cd-qty span'); qty+=q?parseInt(q.textContent,10)||0:1;
    });
    return {vids:vids, qty:qty};
  }
  function render(){
    if(body.querySelector('.cu')||!body.querySelector('.cd-item')) return;
    var c=inCart(), free=c.qty<OFFER;
    var pick=RINGS.filter(function(r){ return !r.v.some(function(v){ return c.vids[String(v.id)]; }); }).slice(0,MAX);
    if(!pick.length) return;
    var h='<div class="cu" aria-label="You might also like"><div class="cu-h">You might also like</div>';
    pick.forEach(function(r){
      var av=r.v.filter(function(v){ return v.a; }); if(!av.length) return;
      var price=free?'<s>'+money(av[0].p)+'</s>FREE':money(av[0].p), ctl;
      var ci=r.o.findIndex(function(n){ return /colo/i.test(n); });
      if(av.length===1&&r.v.length===1) ctl='<span class="cu-one">'+esc(label(r,av[0]))+'</span>';
      else if(ci>-1) ctl=swatchCtl(r,av,ci);   // Ivan 2026-10-06: colour as metal swatches, size only when a ring has real sizes
      else ctl='<select class="cu-sel" aria-label="'+esc(prompt(r))+' for '+esc(r.t)+'"><option value="">'+esc(prompt(r))+'</option>'
        +av.map(function(v){ return '<option value="'+v.id+'">'+esc(label(r,v))+'</option>'; }).join('')+'</select>';
      h+='<div class="cu-row" data-h="'+esc(r.h)+'" data-one="'+(r.v.length===1?av[0].id:'')+'">'
        +'<a class="cu-img" href="'+esc(r.u)+'">'+(r.img?'<img src="'+esc(r.img)+'" alt="" width="64" height="64">':'')+'</a>'
        +'<div><div class="cu-top"><a class="cu-name" href="'+esc(r.u)+'">'+esc(r.t)+'</a><span class="cu-price">'+price+'</span></div>'
        +'<div class="cu-ctl">'+ctl+'<button type="button" class="cu-add">+ Add</button></div></div></div>';
    });
    body.insertAdjacentHTML('beforeend',h+'</div>');
  }
  body.addEventListener('change',function(e){ if(e.target.classList.contains('cu-sel')) e.target.classList.remove('cu-need'); var row=e.target.closest('.cu-row'); if(row&&e.target.classList.contains('cu-size')) resolve(row); });
  body.addEventListener('click',function(e){
    var sw=e.target.closest('.cu-sw'); if(!sw) return;
    var row=sw.closest('.cu-row'); row.querySelectorAll('.cu-sw').forEach(function(x){ x.classList.toggle('on',x===sw); x.setAttribute('aria-checked',x===sw?'true':'false'); });
    row.querySelector('.cu-sws').classList.remove('cu-need'); resolve(row);
  });
  body.addEventListener('click',function(e){
    var b=e.target.closest('.cu-add'); if(!b) return;
    var row=b.closest('.cu-row'), sws=row.querySelector('.cu-sws'), sel=row.querySelector('.cu-sel');
    var id=row.getAttribute('data-one')||(sws?resolve(row):(sel&&sel.value));
    if(!id){
      if(sws&&!row.querySelector('.cu-sw.on')){ sws.classList.add('cu-need'); if(window.cdToast) cdToast('Choose a colour first'); return; }
      if(sel){ sel.classList.add('cu-need'); sel.focus(); } if(window.cdToast) cdToast(sws?'Choose a size first':(sel?sel.options[0].text+' first':'Sold out')); return;
    }
    b.disabled=true; b.textContent='Adding';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
      .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; }); })
      .then(function(){ if(window.cdToast) cdToast('Added to your cart'); if(window.cdShow) cdShow(); })
      .catch(function(err){ b.disabled=false; b.textContent='+ Add'; if(window.cdToast) cdToast((err&&(err.description||err.message))||'Could not add this ring'); });
  });
  new MutationObserver(render).observe(body,{childList:true});
  render();
})();
